<script setup lang="ts">
import {
  type ServiceFilters,
  type Service,
  useGetServicesInfinite,
} from '@/features/services';
import { DEBOUNCE_INTERVAL_MS } from '@glow/shared/lib/constants';
import { refDebounced } from '@vueuse/shared';

const props = defineProps<{
  searchQuery?: string;
}>();
const emit = defineEmits<{
  (e: 'select', service: Service): void;
}>();

const filters = computed<ServiceFilters>(() => ({
  name: props.searchQuery,
}));
const filtersDebounced = refDebounced(filters, DEBOUNCE_INTERVAL_MS);
const {
  data: servicesInfinite,
  isInitialLoading,
  isRefetching,
} = useGetServicesInfinite(filtersDebounced);
const services = useFlatInfiniteData(servicesInfinite);
</script>

<template>
  <div class="service-list">
    <AppLoader
      v-if="isInitialLoading || isRefetching"
      class="service-list__loader"
    />
    <AppGroup>
      <div
        v-for="service in services?.slice(0, 5)"
        :key="service.id"
        class="service-list__item"
        @mousedown="emit('select', service)"
      >
        {{ service.name }}
      </div>
    </AppGroup>
  </div>
</template>

<style scoped lang="scss">
.service-list {
  &__loader {
    padding: 15px 0;
  }

  &__item {
    padding: 10px 20px;
    cursor: pointer;

    &:hover {
      background-color: #f1f1f1;
    }
  }
}
</style>
